(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LSinyourhomes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wake(img) {
      if (img.dataset.srcset) { img.setAttribute('srcset', img.dataset.srcset); delete img.dataset.srcset; }
      if (img.dataset.src) { img.setAttribute('src', img.dataset.src); delete img.dataset.src; }
      img.classList.remove('lsiyh__img--wait');
    }
    function arm(track) {
      if (track.dataset.lsiyhArmed) return;
      track.dataset.lsiyhArmed = '1';
      var imgs = [].slice.call(track.querySelectorAll('.lsiyh__img--wait'));
      if (!imgs.length) return;
      if (!('IntersectionObserver' in window)) { imgs.forEach(wake); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          wake(e.target);
          io.unobserve(e.target);
        });
      }, { root: track, rootMargin: '0px 200px 0px 200px' });
      imgs.forEach(function (img) { io.observe(img); });
    }
    function init() { document.querySelectorAll('.lsiyh__track').forEach(arm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
